import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { isEmpty } from '@chegg/utils';
import { executeCommands } from './CommandState.actions';
import { loopCommands } from './commands/loopCommands';
export var executeCommandsListener = function executeCommandsListener(middleware) {
  return middleware.startListening({
    actionCreator: executeCommands,
    effect: function () {
      var _effect = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(action, _ref) {
        var getState, dispatch, state, commands;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              getState = _ref.getState, dispatch = _ref.dispatch;
              state = getState();
              commands = action.payload;
              if (!(!commands || isEmpty(commands))) {
                _context.next = 5;
                break;
              }
              return _context.abrupt("return");
            case 5:
              loopCommands(state, commands, dispatch);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      function effect(_x, _x2) {
        return _effect.apply(this, arguments);
      }
      return effect;
    }()
  });
};
export default [executeCommandsListener];


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/CommandState/CommandState.listener.js
// module id = 4401
// module chunks = 11